/* eslint-disable jsx-a11y/anchor-is-valid */
import { Table, Switch } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { t_machine } from 'types';

type ItemTable = {
  itemTable: t_machine[];
  onChangeDevice: (machineId: string, _e: boolean) => void;
  deviceChoose: string[];
};

const TableUpdate: FC<ItemTable> = ({ itemTable, onChangeDevice, deviceChoose }) => {
  const { listPatient } = useSelector((state: RootState) => state.machine);
  return (
    <div>
      <Table
        columns={[
          {
            title: '',
            dataIndex: 'index',
            key: 'index',
            width: '5%',
            align: 'right',
            render(text: string, row: any, index: any) {
              return {
                props: {
                  style: { textAlign: 'right' },
                  className: 'standardFont',
                },
                children: <div>{index + 1}</div>,
              };
            },
          },
          {
            title: '機種',
            dataIndex: 'machine_type_name',
            key: 'machine_type_name',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '機種',
            dataIndex: 'machine_other',
            key: 'machine_other',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: 'シリアルナンバー',
            dataIndex: 'machine_serial_number',
            key: 'machine_serial_number',
            align: 'left',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '患者名',
            dataIndex: 'patient_name',
            key: 'patient_name',
            align: 'left',
            render(text: string, row: any) {
              const listPatientOfMachine = listPatient?.filter((patient: any) => patient.machine_id === row.machine_id);

              const namePatient = listPatientOfMachine
                ?.map((name: any) => {
                  return name.patient_name;
                })
                .join(', ');
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{namePatient}</div>,
              };
            },
          },
          {
            title: '備考',
            dataIndex: 'machine_remark',
            key: '',
            align: 'left',
            render(text: string, record: any, index: number) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '返却する',
            dataIndex: 'Status',
            key: '',
            align: 'center',
            render(text: string, row: any, index: number) {
              let isCheck = text === '返却' ? true : false;
              return {
                props: {
                  style: { textAlign: 'center' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Switch
                      checkedChildren="返却"
                      onChange={(_e) => {
                        onChangeDevice(row.i_id, _e);
                      }}
                      unCheckedChildren=""
                      defaultChecked={isCheck}
                    />
                  </div>
                ),
              };
            },
          },
        ]}
        dataSource={itemTable}
        pagination={false}
      />
    </div>
  );
};
export default TableUpdate;
